import React from 'react'
import cx from 'classnames'

import RefinementList from '~components/search/refinement-list'

const Refinement = ({ label, labelClasses, attribute, defaultRefinement, hidden }) => {
  return (
    <div id={label.toLowerCase()} className={cx(hidden && 'hidden')}>
      <div className={labelClasses}>{label}</div>
      <div className='font-nunito font-semibold text-sm'>
        <RefinementList label={label} attribute={attribute} defaultRefinement={defaultRefinement} limit={50} />
      </div>
    </div>
  )
}

export default Refinement
